import { apiFetch } from "./client";
import type { AppSetting, Page } from "./types";
import type { ListParams } from "./customers";

export async function listSettings(params: ListParams = {}): Promise<Page<AppSetting>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch(`/settings${query ? `?${query}` : ""}`);
}

export async function updateSetting(key: string, value: string): Promise<AppSetting> {
  return apiFetch(`/settings/${encodeURIComponent(key)}`, {
    method: "PUT",
    body: JSON.stringify({ value }),
  });
}

/** Decrypted Google Maps API key for the route planner (authenticated). */
export async function getMapsKey(): Promise<{ api_key: string }> {
  return apiFetch("/settings/maps-key");
}
